import { apiClient } from '@/shared/api';
import type {
  StrategistCellDialogsRequest,
  StrategistCellDialogsResponse,
  StrategistConceptCardRequest,
  StrategistConceptCardResponse,
  StrategistConceptsRequest,
  StrategistConceptsResponse,
  StrategistHierarchyRequest,
  StrategistHierarchyResponse,
  StrategistMatrixRequest,
  StrategistMatrixResponse,
  StrategistStandardsMatrixRequest,
  StrategistStandardsMatrixResponse,
  StrategistTransitionsRequest,
  StrategistTransitionsResponse,
} from '../types';

/**
 * POST /strategist-data/concepts — список концептов с агрегатами по выборке.
 */
export const fetchConcepts = async (body: StrategistConceptsRequest): Promise<StrategistConceptsResponse> => {
  const { data } = await apiClient.post<StrategistConceptsResponse>('/strategist-data/concepts', body);
  return data;
};

/**
 * POST /strategist-data/concept — карточка одного понятия: агрегаты и реальные
 * реплики (дословный анонимизированный текст) по разным диалогам выборки.
 */
export const fetchConceptCard = async (body: StrategistConceptCardRequest): Promise<StrategistConceptCardResponse> => {
  const { data } = await apiClient.post<StrategistConceptCardResponse>('/strategist-data/concept', body);
  return data;
};

/**
 * POST /strategist-data/matrix — матрица «возражение × аргумент».
 */
export const fetchMatrix = async (body: StrategistMatrixRequest): Promise<StrategistMatrixResponse> => {
  const { data } = await apiClient.post<StrategistMatrixResponse>('/strategist-data/matrix', body);
  return data;
};

/**
 * POST /strategist-data/transitions — переходы «возражение → следующий аргумент».
 */
export const fetchTransitions = async (body: StrategistTransitionsRequest): Promise<StrategistTransitionsResponse> => {
  const { data } = await apiClient.post<StrategistTransitionsResponse>('/strategist-data/transitions', body);
  return data;
};

/**
 * POST /strategist-data/standards-matrix — матрица «понятие × блок стандарта».
 */
export const fetchStandardsMatrix = async (
  body: StrategistStandardsMatrixRequest,
): Promise<StrategistStandardsMatrixResponse> => {
  const { data } = await apiClient.post<StrategistStandardsMatrixResponse>('/strategist-data/standards-matrix', body);
  return data;
};

/**
 * POST /strategist-data/cell-dialogs — диалоги за ячейкой матрицы (пара
 * возражение×аргумент либо понятие×блок стандарта) и влияние ячейки.
 */
export const fetchCellDialogs = async (body: StrategistCellDialogsRequest): Promise<StrategistCellDialogsResponse> => {
  const { data } = await apiClient.post<StrategistCellDialogsResponse>('/strategist-data/cell-dialogs', body);
  return data;
};

/**
 * POST /strategist-data/hierarchy — кластеры понятий выбранной категории на пороге близости.
 */
export const fetchHierarchy = async (body: StrategistHierarchyRequest): Promise<StrategistHierarchyResponse> => {
  const { data } = await apiClient.post<StrategistHierarchyResponse>('/strategist-data/hierarchy', body);
  return data;
};
